module.exports = __webpack_public_path__ + "img/shezhi copy.f511f7c6.png";